import * as React from "react"
import { Link as RouterLink, type LinkProps as RouterLinkProps } from "react-router-dom"

import { cn } from "@/lib/utils"

export interface LinkProps extends RouterLinkProps {
  className?: string
}

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, ...props }, ref) => {
    return (
      <RouterLink
        ref={ref}
        className={cn("no-underline hover:no-underline", className)}
        {...props}
      />
    )
  }
)
Link.displayName = "Link"

export { Link }

